import { render } from "./exchange.vue?vue&type=template&id=0ed9feca&scoped=true"
import script from "./exchange.vue?vue&type=script&lang=js"
export * from "./exchange.vue?vue&type=script&lang=js"

import "./exchange.vue?vue&type=style&index=0&id=0ed9feca&lang=scss&scoped=true"
import "./exchange.vue?vue&type=style&index=1&id=0ed9feca&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed9feca"]])

export default __exports__